// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".assignment-counts{font-size:10px;text-align:right}.assignment-counts .btn-link{cursor:pointer}.btn-save{margin-top:0!important;padding:.45rem .8rem!important}", ""]);
// Exports
module.exports = exports;
